module.exports = __webpack_public_path__ + "img/BRCA2_Mast.a900babc.png";